import { Checkbox, CheckboxIcon, CheckboxIndicator, CheckIcon, View } from '@gluestack-ui/themed'
import React, { PureComponent } from 'react'
import { StyleSheet, TouchableWithoutFeedback } from 'react-native'
import { FormSingleCheckbox } from '../../../api/Form/types'
import { ThemeState } from '../../../redux/theme/types'
import { theme } from '../../../theme'
import { LabelInput } from '../components'
import { FormElementProps } from '../types'

type SingleCheckboxProps = FormElementProps<FormSingleCheckbox, boolean> & ThemeState

class SingleCheckboxFieldClass extends PureComponent<SingleCheckboxProps> {
  public focus = () => {}

  public render() {
    const { field, value, setFieldValue } = this.props
    const setCheckbox = () => setFieldValue(this.elementId, !value)
    const color = this.props.toolbarDefaultBg || theme.colors.silver

    return (
      <TouchableWithoutFeedback onPress={setCheckbox}>
        <View style={styles.body}>
          <LabelInput text={field.libelle} style={styles.label} required={field.constraint.mandatory} />
          <Checkbox value={(value || 0).toString()} isChecked={value} onChange={setCheckbox}>
            <CheckboxIndicator style={[styles.checkbox, { borderColor: color }]}>
              <CheckboxIcon as={CheckIcon} color={theme.colors.white} />
            </CheckboxIndicator>
          </Checkbox>
        </View>
      </TouchableWithoutFeedback>
    )
  }

  private get elementId() {
    const { field } = this.props
    return `${field.id}`
  }
}

const styles = StyleSheet.create({
  body: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  checkbox: {
    marginRight: 0,
  },
  label: {
    flex: 1,
    paddingRight: theme.padding.x4,
  },
})

export { SingleCheckboxFieldClass }
